export default __webpack_public_path__ + "static/media/fondo-student-dashboard-default.fb79be30.jpg";